import axios from "axios";
import { instalarCifrado } from "../utils/cifrado";

/**
 * Cliente para las pantallas PÚBLICAS: el enlace que recibe el visitante.
 *
 * Existe aparte del cliente normal por dos razones concretas:
 *
 *  1. El interceptor del cliente autenticado hace `logout()` y redirige a
 *     `/login` ante cualquier 401. Un visitante que abre un enlace vencido no
 *     tiene sesión que cerrar: lo que veía era la pantalla de acceso del
 *     sistema, sin explicación.
 *  2. El cliente normal adjunta el token de quien esté conectado. Si un
 *     residente abría el enlace de un QR, su token viajaba a una ruta pública
 *     que no lo necesita. Aquí no se manda ninguno.
 *
 * El cifrado de extremo a extremo SÍ se aplica: el handshake no requiere
 * sesión, y lo que viaja de vuelta —nombre del visitante, casa, polígono— es
 * justamente lo que hay que proteger.
 */
const instanciaPublica = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

instalarCifrado(instanciaPublica);

export default instanciaPublica;
